import { FC, useEffect, useState } from "react";
import { appointmentDetails } from "../../../../types/calendar";
import { useSelector } from "react-redux";
import { Modal, Popover } from "antd";
import AppointmentDetailsModalWrapper from "../AppointmentDetails/AppointmentDetailsModalWrapper";
import {
  formateTimeToAMPM,
  getAppointMentStatus,
} from "../../../../utils/DateUtils";
import { useSearchParams } from "react-router-dom";
import { useIntl } from "react-intl";
interface AppointmentsProps {
  appointments: appointmentDetails[];
}

function calculateTimeDifference(startTime: string, endTime: string) {
  const [startHour, startMinute] = startTime.split(":").map(Number);
  const [endHour, endMinute] = endTime.split(":").map(Number);

  // Convert times to seconds
  const startTimeInSeconds = startHour * 3600 + startMinute * 60;
  const endTimeInSeconds = endHour * 3600 + endMinute * 60;

  // Calculate the time difference in seconds
  const timeDifferenceInSeconds = endTimeInSeconds - startTimeInSeconds;

  // Convert the time difference to hours (divide by 3600)
  const timeDifferenceInHours = timeDifferenceInSeconds / 3600;

  return timeDifferenceInHours;
}

const bgColor = {
  completed: " bg-[#479821]",
  started: " bg-[#A9AEF6]",
  pending: " bg-[#A9AEF6]",
  canceled: " bg-[#EEF0FF]",
  created: "bg-color-primary",
  no_show: "",
  arrived: "",
  overdue: "bg-[#CF953D]",
};

const textColor = {
  completed: "text-white",
  started: "text-white",
  pending: "text-white",
  canceled: "text-white",
  created: "text-white",
  overdue: "text-white",
  no_show: "",
  arrived: "",
};
const getAppointmentPosition = (appointment: appointmentDetails) => {
  let childStyle = {
    bgColor: bgColor?.[appointment?.status] || "",
    titleColor:
      appointment.status === "canceled" ? "" : textColor?.[appointment?.status],
    descColor: appointment.status === "started" ? "text-white" : "",
  };

  const startTime = appointment.start_time.split(":");
  const startMinutes = Number(startTime[1]) / 60;
  const startSpan = String((Number(startTime[0]) + startMinutes) * 112.5);

  const timeDiff = calculateTimeDifference(
    appointment.start_time,
    appointment.finish_time
  );
  // const shiftedHour = Number(startSpan) - 784;
  const shiftedHour = (Number(startSpan) - 784 + 2688) % 2688;

  const result = {
    childStyle,
    height: timeDiff * 112.5,
    top: shiftedHour,

    colStart: String(new Date(appointment.date).getDay() + 1),
  };

  return result;
};

const Appointments: FC<AppointmentsProps> = ({ appointments }) => {
  const intl = useIntl();
  let [searchParams, setSearchParams] = useSearchParams();

  const [open, setOpen] = useState(searchParams.get("id") ? true : false);
  const { selectedTeamMember, currentLang } = useSelector(
    (state: {
      calendar: { selectedTeamMember: number | null };
      user: { currentLang: "en" | "ar" };
    }) => {
      return {
        selectedTeamMember: state.calendar.selectedTeamMember,
        currentLang: state.user.currentLang,
      };
    }
  );
  const [selectedAppointment, setSelectedAppointment] =
    useState<appointmentDetails | null>(
      searchParams.get("id") ? ({ id: searchParams.get("id") } as any) : null
    );
  useEffect(() => {
    if (searchParams.get("id")) {
      searchParams.delete("id");
      setSearchParams(searchParams);
    }
  }, []);
  type formatedAppType = appointmentDetails & {
    position: {
      childStyle: {
        bgColor: string;
        titleColor: string;
        descColor: string;
      };
      height: number;
      top: number;
      colStart: string;
      width?: number;
      margin?: number;
    };
    pushed?: boolean;
  };
  const [appointmentsToRender, setAppointmentsToRender] = useState<
    formatedAppType[][]
  >([]);

  function formatAppointmentsViewAll() {
    const tempArr: formatedAppType[] = [];
    const formattedAppointments: formatedAppType[] = appointments.map((app) => {
      const startI = +app.start_time.split(":").slice(0, 2).join("");
      const endI = +app.finish_time.split(":").slice(0, 2).join("");

      if (startI < 700 && endI > 700) {
        tempArr.push({
          ...app,
          position: getAppointmentPosition({ ...app, start_time: "07:00:00" }),
        });
        return {
          ...app,
          position: getAppointmentPosition({ ...app, finish_time: "07:00:00" }),
        };
      }
      return { ...app, position: getAppointmentPosition(app) };
    });
    formattedAppointments.sort((a, b) => {
      const startA = +a.start_time.split(":").slice(0, 2).join("");
      const endA = +a.finish_time.split(":").slice(0, 2).join("");
      const startB = +b.start_time.split(":").slice(0, 2).join("");
      const endB = +b.finish_time.split(":").slice(0, 2).join("");
      return startA - startB || endA - endB;
    });
    if (tempArr.length > 0) {
      formattedAppointments.push(...tempArr);
    }

    const arr: formatedAppType[][] = [];
    for (let i = 0; i < formattedAppointments.length; i++) {
      if (formattedAppointments[i].pushed) {
        continue;
      }

      const secArr: formatedAppType[] = [];

      secArr.push(formattedAppointments[i]);
      formattedAppointments[i].pushed = true;
      let maxStart = 0;
      let maxEnd = 0;
      for (let j = 0; j < formattedAppointments.length; j++) {
        if (formattedAppointments[i].id !== formattedAppointments[j].id) {
          if (formattedAppointments[i].date === formattedAppointments[j].date) {
            const startI = +formattedAppointments[i].start_time
              .split(":")
              .slice(0, 2)
              .join("");
            const endI = +formattedAppointments[i].finish_time
              .split(":")
              .slice(0, 2)
              .join("");
            const startJ = +formattedAppointments[j].start_time
              .split(":")
              .slice(0, 2)
              .join("");
            const endJ = +formattedAppointments[j].finish_time
              .split(":")
              .slice(0, 2)
              .join("");

            if (maxEnd === 0) {
              maxEnd = endI;
            }
            if (maxStart === 0) {
              maxStart = startI;
            }
            if (maxStart >= endJ || maxEnd <= startJ) {
              continue;
            }
            if (formattedAppointments[j].pushed) {
              continue;
            }

            if (startJ < maxStart) {
              maxStart = startJ;
            }
            if (endJ > maxEnd) {
              maxEnd = endJ;
            }

            secArr.push(formattedAppointments[j]);
            formattedAppointments[j].pushed = true;
          }
        }
      }
      console.log("Here>>>: ", formattedAppointments[i].id, maxStart, maxEnd);

      arr.push(secArr);
    }
    setAppointmentsToRender(arr);
  }

  useEffect(() => {
    formatAppointmentsViewAll();
  }, [appointments, selectedTeamMember]);

  return (
    <ol
      className="relative col-start-1 col-end-2 row-start-1 grid grid-cols-1 mt-6 "
      style={{
        gridTemplateRows: "1.75rem repeat(288, minmax(0, 1fr)) auto",
      }}
    >
      {selectedAppointment !== null ? (
        <Modal
          width={700}
          open={open}
          footer={null}
          onCancel={() => {
            setOpen(false);
            setSelectedAppointment(null);
          }}
          destroyOnClose={true}
        >
          <AppointmentDetailsModalWrapper
            setIsModalOpen={setOpen}
            appointment={selectedAppointment}
          />
        </Modal>
      ) : null}
      {appointmentsToRender?.map(
        (childAppointments: formatedAppType[], index) => {
          return childAppointments.map((appointment, i) => {
            const position = appointment?.position;
            const { childStyle, height, top } = position ?? {};
            const { bgColor, titleColor, descColor } = childStyle ?? {};
            return (
              <Popover
                key={appointment.id}
                content={
                  <div className={`flex justify-end p-2 rounded w-[300px]`}>
                    <div className="flex flex-col justify-center gap-2  w-full">
                      <p
                        className={` text-center `}
                        style={{
                          color:
                            appointment?.status === "canceled"
                              ? "red"
                              : bgColor.replace("[", "").replace("]", ""),
                        }}
                      >
                        {getAppointMentStatus(appointment?.status, currentLang)}
                      </p>
                      <p className="">
                        <time>
                          {formateTimeToAMPM(
                            appointment.start_time,
                            currentLang
                          )}{" "}
                          -{" "}
                          {formateTimeToAMPM(
                            appointment.finish_time,
                            currentLang
                          )}{" "}
                        </time>
                      </p>
                      <div className={descColor}>
                        {appointment?.appointment_services?.map((service) => (
                          <p
                          //  className={titleColor}
                          >
                            {service?.service?.name}
                          </p>
                        ))}
                      </div>
                      <div className={descColor}>
                        {appointment?.appointment_packages?.map((pkg) => (
                          <p
                          //  className={titleColor}
                          >
                            {pkg?.package?.name}
                          </p>
                        ))}
                      </div>
                      <div className="flex gap-2  bg-[#EEF0FF] font-semibold  p-2 justify-between rounded">
                        <p className="flex gap-2 items-center">
                          <span>
                            {intl.formatMessage({
                              id: "totalPrice",
                            })}
                          </span>
                        </p>

                        <p className="flex gap-1 items-center ">
                          <span className="text-lg text-color-primary">
                            {appointment?.cost}
                          </span>
                          <small className="text-xs self-center mt-2">
                            {intl.formatMessage({
                              id: "SARshort",
                            })}
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>
                }
                trigger="hover"
              >
                <li
                  key={appointment.id}
                  className={"absolute flex z-10   "}
                  style={{
                    height: `${height}px`,
                    top: `${top}px`,

                    width: `${100 / childAppointments.length}%`,
                    [currentLang === "ar" ? "right" : "left"]: `${
                      childAppointments.length > 1
                        ? (100 / childAppointments.length) * i
                        : 0
                    }%`,
                  }}
                  onClick={() => {
                    setSelectedAppointment(appointment);
                    setOpen(true);
                  }}
                >
                  <a
                    className={`group absolute inset-1 flex flex-col justify-center  overflow-y-auto rounded-lg p-2 text-xs leading-5  transition-all ${bgColor}`}
                    style={{
                      border: "1px solid white",
                      borderRadius: "0.5rem",
                      opacity: 0.7,
                    }}
                  >
                    <div className="flex justify-between gap-2 items-center">
                      <div className="flex flex-col gap-1">
                        <div className={descColor}>
                          {appointment?.appointment_services?.map((service) => (
                            <p className={titleColor}>
                              {service?.service?.name}
                            </p>
                          ))}
                        </div>
                        <div className={descColor}>
                          {appointment?.appointment_packages?.map((pkg) => (
                            <p className={titleColor}>{pkg?.package?.name}</p>
                          ))}
                        </div>
                      </div>
                      <p className={titleColor}>
                        <time dateTime="2022-01-12T06:00">
                          {formateTimeToAMPM(
                            appointment.start_time,
                            currentLang
                          )}{" "}
                          -{" "}
                          {formateTimeToAMPM(
                            appointment.finish_time,
                            currentLang
                          )}{" "}
                        </time>
                      </p>
                      <p
                        className={` font-bold text-center ${
                          appointment?.status === "canceled"
                            ? " text-[red]"
                            : "text-[white]"
                        }  `}
                      >
                        {getAppointMentStatus(appointment?.status, currentLang)}
                      </p>
                    </div>
                  </a>
                </li>
              </Popover>
            );
          });
        }
      )}
    </ol>
  );
};

export default Appointments;
